import { useState } from 'react';
import { Input } from '../../../components/Form/Input';
import { forgotPasswordAction } from '../authActions';
import { useModalStore } from '../../../shared/store/uiStore';

const ForgotPassword = () => {
  const [error, setError] = useState<string | null>(null);
  const { closeModal } = useModalStore((state) => state);
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget as HTMLFormElement);
    const email = formData.get('email') as string;

    const err = await forgotPasswordAction(email);

    if (!err) {
      closeModal();
      return;
    }

    if (err?.message) {
      {
        setError(err?.message);
      }
    }
  };

  return (
    <form
      id='forgot-password-form'
      onSubmit={handleSubmit}
      className='flex flex-col gap-x-4'
    >
      {error && <div className=' text-red-500 text-center'>{error}</div>}
      <Input
        label='Email'
        type='email'
        name='email'
        placeholder='Enter your email'
        required
        className='w-full'
      />
    </form>
  );
};
export default ForgotPassword;
